import $ from "jquery";
import { initNotificationBadgeWebComponent } from "./notificationBadge/notificationBadge";
import { initNotificationBadgePollerWebComponent, NotificationPollerElement } from "./notificationBadge/notificationBadgePoller";
import { initNotificationBadgeSSEWebComponent } from "./notificationBadge/notificationBadgeSSE";

initNotificationBadgeWebComponent();
initNotificationBadgePollerWebComponent();
initNotificationBadgeSSEWebComponent();

export class Notifications {

    public componentType = "notifications";
    public view: NotificationPollerElement;

    public render(): Element {
        let jqview = $("<notification-poller>");
        this.view = jqview[0] as NotificationPollerElement;
        return this.view;
    }

    public value(data) {
        if (data.url == null) {
            this.view.data = data;
        } else {
            this.view.setAttribute("url", data.url);
        }
    }
}
